<template>
    <van-overlay :show="showed" v-bind="$attrs" :z-index="3000">
        <div class="dialog" @click.stop>
            <div class="close" @click="handleClose"></div>
            <div class="bg"><img src="@/assets/img/dialog/welcome-signup/kuang.png" /></div>
            <div class="title">{{ $t('sign_up_gift_1') }}</div>
            <div
                class="num"
                v-html="
                    $t('sign_up_gift_2', {
                        current_type: store.cureencySymbol(),
                        number: formatNumber(data.config?.worth || 0, Number.isInteger(data.config?.worth || 0) ? 0 : 2),
                    })
                "
            ></div>
            <div class="btn" @click="goLogin">{{ $t('Reg_button') }}</div>
        </div>
    </van-overlay>
</template>
<script setup lang="ts">
import popupManager from '@/utils/PopupManager'
import { formatNumber } from '@/utils/toolsValidate'
import { useBaseStore } from '@/stores'
import { useRouter } from 'vue-router'
import { getRegistGifts } from '@/api/home'
import { Log } from '@/api/log'

const store = useBaseStore()
const router = useRouter()

const showed = defineModel()

const regeistData = ref({})

const data = computed(() => {
    const { claimed, config, items } = store.gameList
    if (typeof claimed === 'boolean') {
        return {
            claimed,
            config,
            items,
        }
    }
    return regeistData.value
})

const goLogin = () => {
    showed.value = false
    popupManager.checkQueue()
    router.push('/login')
}
const handleClose = () => {
    showed.value = false
    popupManager.checkQueue()
}
const getGift = () => {
    const claimed = store.gameList.claimed
    if (typeof claimed === 'boolean') {
        showed.value = true
    } else {
        getRegistGifts().then((res) => {
            if (res.code === 200) {
                showed.value = true
                regeistData.value = res.data
            } else {
                popupManager.checkQueue()
            }
        })
    }
}

onMounted(() => {
    if (!store.token) {
        getGift()
        Log({
            event: 'unRegister_welcome',
        })
    } else {
        popupManager.checkQueue()
    }
})
</script>
<style lang="scss" scoped>
.dialog {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 750px;
    padding: 0 37px;
    transform: translate3d(-50%, -50%, 0);
    font-family: Helve;

    .close {
        position: absolute;
        width: 54px;
        height: 54px;
        top: 60px;
        right: 76px;
        background: url('@/assets/img/close.png') no-repeat center center;
        background-size: 27px 27px;
    }

    .bg {
        margin: 0 auto -132px;
        width: 645px;
        height: 617px;
        .img {
            width: 100%;
            height: 100%;
        }
    }
    .title {
        margin-bottom: 35px;
        font-family: MicrosoftYaHei;
        font-size: 32px;
        line-height: 38px;
        line-height: 34px;
        letter-spacing: -1px;
        color: #fff050;
        font-weight: bold;
    }
    .num {
        margin-top: -20px;
        color: #fff050;
        font-size: 130px;
        font-family: Helvet;

        :deep(span) {
            margin-right: 15px;
            font-family: Helvet;
        }
    }
    .btn {
        @apply flex justify-center items-center;
        margin: 0 auto;
        width: 332px;
        height: 88px;
        font-family: MicrosoftYaHei;
        font-size: 44px;
        font-weight: 600;
        font-weight: bold;
        color: #fff;
        border-radius: 100px;
        background: linear-gradient(0deg, #fa3374 0%, #ff7aa5 100%);
        box-shadow: 0px 2px 0px 0px rgba(255, 255, 255, 0.25) inset;
    }
}
</style>
